import dayjs from "dayjs";
import { imageError } from "../../../functions/error";
import { IPaymentTracking } from "../../../interfaces/paymentTracking";
import { IPets } from "../../../interfaces/pets";
import {
  AvatarProfile,
  Container,
  ContainerDetailProfile,
  ContainerHeaderCard,
  LastChat,
  NotiPoint,
  TextDate,
  TextDetail,
} from "./index.style";
interface Props extends IPaymentTracking {
  isRead: boolean;
  pet?: IPets;
  timestamp?: string | number | Date;
  isDoctorOwnerLastChat?: boolean;
  lastChat?: string;
}

const DEFAULT =
  "https://firebasestorage.googleapis.com/v0/b/pettinee-prodz.appspot.com/o/default%2Fimage-error.png?alt=media&token=42a3970b-51bf-43b4-854e-516c68d08ab2";
const ChatList = (props: Props) => {
  return (
    <Container>
      <ContainerHeaderCard>
        <AvatarProfile
          alt="profile-image-avatar"
          src={props.imageUrl ?? DEFAULT}
          onError={imageError}
        />
        <ContainerDetailProfile>
          {/* User Detail */}
          <h4 className="text-n-color">
            {props.displayName} {props.status === 4 && "(ติดตามผลการรักษา)"}
          </h4>
          <p className="text-h-color">
            ชื่อ:<span>{" " + props.pet?.petName} </span>
            สัตว์เลี้ยง:<span>{" " + props.pet?.petType}</span>
          </p>
        </ContainerDetailProfile>
      </ContainerHeaderCard>
      <LastChat>
        {props.isDoctorOwnerLastChat
          ? `คุณ : ${props.lastChat}`
          : props.lastChat
          ? `${props.displayName} : ${props.lastChat}`
          : ""}
      </LastChat>
      <TextDate>
        {props.timestamp &&
          dayjs(props.timestamp).format("MMMM D, YYYY h:mm A")}
      </TextDate>
      <TextDetail>
        {props.endDate && (
          <>
            สิ้นสุดวันที่:
            <span>
              {"  " + dayjs(props.endDate).format("DD/MM/YYYY")}{" "}
              {props.status === 4 && "(ติดตามผลการรักษา)"}
            </span>
          </>
        )}
        {props.product.productName && (
          <>
            แพ็กแกจ:
            <span>{"  " + props.product.productName}</span>
          </>
        )}
      </TextDetail>
      {!props.isRead && <NotiPoint />}
    </Container>
  );
};

export default ChatList;
